


















import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import MainTabs from '@/components/MainTabs.vue';
import LoginView from '@/views/LoginView.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';

@Component({
  components: {
    'header-bar': Header,
    'main-tabs': MainTabs,
    login: LoginView,
    'error-message': ErrorMessage
  }
})
export default class App extends Vue {
  public get isAuthenticated(): boolean {
    return this.$store.getters.isAuthenticated;
  }
}
